import { create } from "zustand";

interface ErrorToastState {
  message: string | null;
  showError: (message: string) => void;
  clearError: () => void;
}

export const useErrorToastStore = create<ErrorToastState>((set) => ({
  message: null,
  showError: (message) => set({ message }),
  clearError: () => set({ message: null }),
}));
